import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type ExtendedBuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { proAliasesComponent } from '@nodeTypeConfig/helpers/editComponents/proAliasesComponent';
import { proThemesComponent } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { extendsSection } from '../../helpers/genericConfigHelpers';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
// Extends SECTION => A SECTION inside a Pro Theme and WebConfig FALLBACK_MENU_LEVEL_3 becomes a PRO_MENU_LEVEL_3
export const PRO_MENU_LEVEL_3: ExtendedBuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  validationRules: [],
  information: {
    description: 'Pro Cluster: 3rd level in the navigation/menu structure of the Pro Home Page',
    single: 'Cluster',
    plural: 'Clusters',
    icon: require('../../../../../img/icons/webpage.svg'),
  },
  ...extendsSection,
  isCollapsedByDefault: true,
  buildingBlocks: [{ type: NodeType.SECTION }],
  edit: [titleComponent, proAliasesComponent, proThemesComponent],
  webTab: asideWebBasicConfiguration,
};
